"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLoggerEntity = void 0;
const ObserverList_1 = require("./ObserverList");
function makeLoggerEntity() {
    return new LoggerImp();
}
exports.makeLoggerEntity = makeLoggerEntity;
class LoggerImp {
    constructor() {
        this.logItems = [];
        this.showLog = false;
        this.saveObservers = new ObserverList_1.ObserverList();
        this.logAddedObservers = new ObserverList_1.ObserverList();
        this.filterBy = undefined;
        this.filterValue = undefined;
        this.addLogSaveObserver = (observer) => {
            this.saveObservers.add(observer);
        };
        this.removeLogSavedObserver = (observer) => {
            this.saveObservers.remove(observer);
        };
        this.addLogAddedObserver = (observer) => {
            this.logAddedObservers.add(observer);
        };
        this.removeLogAddedObserver = (observer) => {
            this.logAddedObservers.remove(observer);
        };
        this.log = (sender, message) => {
            const log = this.setNewLog(sender, message, 'LOG');
            this.logAddedObservers.notify(log);
        };
        this.warn = (sender, message) => {
            const log = this.setNewLog(sender, message, 'WARNING');
            this.logAddedObservers.notify(log);
        };
        this.error = (sender, message) => {
            const log = this.setNewLog(sender, message, 'ERROR');
            this.logAddedObservers.notify(log);
        };
        this.fatal = (sender, message) => {
            const log = this.setNewLog(sender, message, 'FATAL');
            this.logAddedObservers.notify(log);
        };
        this.clear = () => {
            this.logItems = [];
        };
        this.downloadLogs = () => {
            const logs = this.getAllLogs();
            this.saveObservers.notify({
                instruction: 'DOWNLOAD',
                payload: {
                    filename: 'playerLogs.json',
                    fileData: {
                        filterBy: this.filterBy,
                        filterValue: this.filterValue,
                        logs,
                    },
                },
            });
        };
        this.getAllLogs = () => {
            return [...this.logItems];
        };
        this.getFilteredLogs = () => {
            return this.logItems.filter((item) => this.filterFormula(item));
        };
    }
    displayAllLogs() {
        const allLogs = this.getFilteredLogs();
        this.saveObservers.notify({
            instruction: 'SHOWALL',
            payload: allLogs,
        });
    }
    toggleShowLogs() {
        this.showLog = !this.showLog;
    }
    setFilter(filterBy, filterValue) {
        this.filterBy = filterBy;
        this.filterValue = filterValue;
    }
    clearFilter() {
        this.filterBy = undefined;
        this.filterValue = undefined;
    }
    setNewLog(sender, message, severity) {
        const log = {
            sender,
            message,
            severity,
        };
        this.logItems.push(log);
        if (this.showLog) {
            this.saveObservers.notify({
                instruction: 'SHOWLOG',
                payload: log,
            });
        }
        return log;
    }
    filterFormula(item) {
        var _a, _b;
        if (this.filterBy) {
            const currentValue = item[this.filterBy].toString().toLocaleLowerCase().trim();
            const desiredValue = (_b = (_a = this.filterValue) === null || _a === void 0 ? void 0 : _a.toString().toLocaleLowerCase().trim()) !== null && _b !== void 0 ? _b : '';
            const exactMatch = currentValue === desiredValue;
            const similarMatch = currentValue.includes(desiredValue);
            if (exactMatch || similarMatch) {
                return item;
            }
        }
        else {
            return item;
        }
    }
}
